import React from 'react';
// @ts-ignore
import styles from './DENTModalOverviewGeneralEndodonticRow.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { getTestButtonText } from '../../Helpers/endodontic/testButtonText';
import useTooth from '../../Hooks/Tooth/useTooth';
import { EndodonticButtonOption } from '../../Helpers/endodontic/endodonticButtonOptions';

interface Props extends EndodonticButtonOption {
	selectTest: (test: EndodonticButtonOption['value']) => void;
}

const DENTModalOverviewGeneralEndodonticRow = ({
	label,
	value,
	selectTest,
}: Props) => {
	const { t } = useTranslation();
	const { endodontic } = useTooth();

	return (
		<div className={styles.wrapper}>
			<span>{t(label)}</span>
			<LinkButton
				title={getTestButtonText(value, endodontic.getEndodontic)}
				theme={Theme.BLUE}
				onClick={() => selectTest(value)}
			/>
		</div>
	);
};

export default DENTModalOverviewGeneralEndodonticRow;
